import {ICartLineItem} from '../../i';

// The list logic of the redesign's recommendations row (ab-redesign-recommend.tsx), kept free of the swiper and the
// store so it can be tested on its own.

/** One recommended product, as /api/rec_prod answers it (WebFrontEnd Pages/api/content/rec_prod.cs). */
export interface IRecommendedProduct {
    url: string;
    ProductID: number;
    ProductTitle: string;
    price: number;
    IsFastShip: boolean;
    image_url: string;
    image_url_th: string;
}

export interface IRecommendationSeed {
    StoreID: number;
    ProductID: number;
}

export const MAX_SEEDS = 3;
export const MAX_PRODUCTS = 8;

/** The (store, product) pairs to ask about: the first distinct ones in cart order, lines without a store or product skipped. */
export function recommendationSeeds(items: Array<Pick<ICartLineItem, 'storeId' | 'productId'>> | undefined, max: number = MAX_SEEDS): IRecommendationSeed[] {
    const seeds: IRecommendationSeed[] = [];
    (items ?? []).forEach(o => {
        if (seeds.length >= max || !(o.storeId > 0) || !(o.productId > 0)) {
            return;
        }
        if (!seeds.some(s => s.StoreID === o.storeId && s.ProductID === o.productId)) {
            seeds.push({StoreID: o.storeId, ProductID: o.productId});
        }
    });
    return seeds;
}

/** The per-seed answers merged in seed order: no product twice, nothing that is already in the cart, at most `max`. */
export function mergeRecommendations(lists: IRecommendedProduct[][], cartProductIds: number[], max: number = MAX_PRODUCTS): IRecommendedProduct[] {
    const out: IRecommendedProduct[] = [];
    lists.forEach(list => {
        (list ?? []).forEach(p => {
            if (out.length >= max || !p || !(p.ProductID > 0) || cartProductIds.includes(p.ProductID) || out.some(x => x.ProductID === p.ProductID)) {
                return;
            }
            out.push(p);
        });
    });
    return out;
}
